module.exports = __webpack_public_path__ + "static/media/avatar2.3970789a.png";